module.exports = __webpack_public_path__ + "img/image_12.34b56179.png";